"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceDebrisCleaningOperation = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var Tags_1 = require("../Tags");
var CardRequirements_1 = require("../CardRequirements");
var AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
var ResourceType_1 = require("../../ResourceType");
var SpaceDebrisCleaningOperation = (function (_super) {
    __extends(SpaceDebrisCleaningOperation, _super);
    function SpaceDebrisCleaningOperation() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SPACE_DEBRIS_CLEANING_OPERATION,
            cost: 7,
            tags: [Tags_1.Tags.MARS, Tags_1.Tags.SPACE],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SPACE, 4); }),
            metadata: {
                cardNumber: 'Pf24',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.titanium(3).br;
                    b.wild(1).asterix().data().cards(1);
                }),
                description: 'Requires 4 space tags. Gain 3 titanium. ' +
                    'Add 1 resource to any card (not cards that take ANIMAL or SCIENCE resources.) ' +
                    'Add 1 data to any card. Draw 1 card.',
            },
        }) || this;
    }
    SpaceDebrisCleaningOperation.prototype.play = function (player) {
        player.addResource(Resources_1.Resources.TITANIUM, 3);
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, undefined, {
            count: 1,
            filter: function (card) {
                return card.resourceType !== undefined && card.resourceType !== ResourceType_1.ResourceType.SCIENCE && !card.tags.includes(Tags_1.Tags.ANIMAL);
            },
        }));
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.DATA, { count: 1 }));
        player.drawCard();
        return undefined;
    };
    return SpaceDebrisCleaningOperation;
}(Card_1.Card));
exports.SpaceDebrisCleaningOperation = SpaceDebrisCleaningOperation;
